/* eslint-disable */
import React, {Component} from 'react';
import './style.less';
import {Carousel, Row, Col, Button, Icon, notification,} from 'antd';

export default class CarouselCon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,

        };
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    onChange(a, b, c) {
        console.log(a, b, c);
    }

    showDetail(ix, item) {
        sessionStorage.newDetailIx = ix;
        if (item.type === 'wechat') {
            window.open(item.url);
        } else {
            window.location.href = '/#/news3';
        }
    }

    renderSingeInfo() {
        let {list,} = this.props;
        const {page} = this.state;
        if (list && list.length > 0) {
            // list = list.reverse();
            return list && list.length > 0 && list.map((ii, index) => {


                if (index >= 4 * (page - 1) && index < 4 * page) {
                    let imgUrl = "img/talents.png", description = "";

                    if (ii) {
                        if (ii['imgList'] && ii['imgList'].length > 0) {
                            imgUrl = ii['imgList'][0]['url'];
                        }
                        if (ii['textList'] && ii['textList'].length > 0) {

                            description = ii['textList'][0];
                            description = this.fontNumber(description);
                            ii.cutTitle = this.fontNumber2(ii.title);
                        }
                    }
                    return (
                        <Col span={6}>
                            <div className={"colT"}>
                                <div><img src={imgUrl}/></div>
                                <div className={"colCon"}>
                                    <p>{ii ? ii['cutTitle'] : ""}</p>
                                    <div style={{color: "#505050", fontSize: "12px"}}>{description}</div>
                                    <div>
                                        <Button size={"small"} onClick={() => this.showDetail(index, ii)} style={{}}>阅读全文<Icon
                                            type="right"/></Button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    )
                }
            });
        }
    }

    fontNumber(date) {
        const length = date.length;
        if (length > 30) {
            var str = '';
            str = date.substring(0, 30) + '......';
            return str;
        } else {
            return date;
        }
    }

    fontNumber2(date) {
        const length = date.length;
        if (length > 15) {
            var str = '';
            str = date.substring(0, 15) + '......';
            return str;
        } else {
            return date;
        }
    }

    showNews() {
        window.location.href = '/#/news2';
    }

    changeLeft() {
        const {page} = this.state;
        if (page > 1) {
            this.setState({page: page - 1});
        } else {
            notification.warning({message: "当前已是第一页!"});
        }
    }

    changeRight() {
        const {list,} = this.props;
        const {page} = this.state;
        if (list && list.length > 0 && page * 4 < list.length) {
            this.setState({page: page + 1});
        } else {
            notification.warning({message: "当前已是最后一页!"});
        }
    }

    render() {
        const {title,} = this.props;

        return (
            <div className={"carouselCon"}>
                <div className="content0">
                    <div className="title-wrapper">
                        <h1 className={"title"}><p>{title}&nbsp;</p></h1>
                    </div>
                </div>
                <Row>
                    <div className={"leftCon"}>
                        <Icon type="left" onClick={() => this.changeLeft()}/>
                    </div>
                    {this.renderSingeInfo()}
                    <div className={"rightCon"}>
                        <Icon type="right" onClick={() => this.changeRight()}/>
                    </div>
                </Row>
                <div className={"bottom"}>
                    <img onClick={() => this.showNews()}
                         style={{width: 80, height: 36}}
                         src="/img/moreBtn.png"/>
                </div>
            </div>
        )
    }
}

